import { ApiClientInstance, DateHelper, LocalizationHelperInstance } from "utils/helpers";
//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
//#endregion

/**
 * @deprecated This service is deprecated. Use useSupportService hook instead.
 *
 * Migration guide:
 * 1. Replace SupportService calls with useSupportService hook
 * 2. Move pure utility functions to appropriate helper files
 * 3. Use Redux hooks for state management
 *
 * @see useSupportService - The replacement hook (already migrated)
 * @see utils/helpers/ - Directory containing utility functions
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const SupportService = {
  getStateText: (state: ApiModels.SupportIssueState) => {
    return LocalizationHelperInstance.getFormattedMessage(`SupportIssue.State_${state}`);
  },

  getSupportCategoryOptions: () => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .SupportCategoryClient.GetOptionsAsync()
      .then((res) => res.data);
  },

  getLatestCommentDate: (support: ApiModels.SupportIssue) => {
    const lastCommentDate =
      support?.comments && support.comments.length > 0 && support.comments[support.comments.length - 1].created;

    return lastCommentDate
      ? DateHelper.getMaxDate([new Date(support.stateChangedTimestamp), new Date(lastCommentDate)])
      : new Date(support!.stateChangedTimestamp);
  },
};

export default SupportService;
